import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/hero-bg.jpg')`
      }}
    >
      <div className="container mx-auto px-4">
        <div className="w-full max-w-4xl">
          <div className="text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              {t('hero.titulo')}
            </h1>
            <p className="text-xl lg:text-2xl mb-8 text-gray-200 leading-relaxed">
              {t('hero.subtitulo')}
              <br />
              <br />
              <strong>{t('hero.destacado1')}</strong>
              <br />
              <strong>{t('hero.destacado2')}</strong>
            </p>
            
            {/* Benefits */}
            <div className="mb-10 space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-teal-400 rounded-full"></div>
                <span className="text-lg">{t('hero.beneficio1')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-teal-400 rounded-full"></div>
                <span className="text-lg">{t('hero.beneficio2')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-teal-400 rounded-full"></div>
                <span className="text-lg">{t('hero.beneficio3')}</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#oferta"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                {t('hero.ctaEstudio')}
              </a>
              <a
                href="#sectores"
                className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                {t('hero.ctaCasos')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
